import React from 'react';
import { PropTypes as PT } from 'prop-types';
import SearchDropdownComp from 'components/SearchDropdown/SearchDropdown';
import FavoritesSearchBar from 'components/Favorites/FavoritesSearchBar';
import FavoritesSearchResults from 'components/Favorites/FavoritesSearchResults';
import classes from './FavoritesSearch.module.scss';

class FavoritesSearch extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      blurred: false
    };
  }

  blurInput = () => {
    this.setState({ blurred: !this.state.blurred });
  };

  isVisible() {
    return this.props.isFocused && this.props.searchString && !!this.props.searchString.length;
  }

  render() {
    return (
      <div className={classes.container}>
        <SearchDropdownComp
          buttonComponent={
            <FavoritesSearchBar {...this.props} blurInput={this.blurInput} blurred={this.state.blurred} />
          }
          menuComponent={<FavoritesSearchResults {...this.props} blurInput={this.blurInput} />}
          isVisible={this.isVisible()}
          clickOutsideHandler={this.props.handleSetIsFocused}
          maxItems={this.props.maxItems}
          itemHeight={40}
        />
      </div>
    );
  }
}

FavoritesSearch.propTypes = {
  handleSetIsFocused: PT.func,
  isFocused: PT.bool,
  maxItems: PT.number,
  searchString: PT.string
};

export default FavoritesSearch;
